import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { FirebaseError } from 'firebase/app';

import { getCollectionLength } from '../utils';

const COLLECTION_PATH = 'organizations';

export const useGetOrganizationsCountFromFirebase = (
  options?: UseQueryOptions<number, FirebaseError, number>,
): UseQueryResult<number, FirebaseError> => useQuery<number, FirebaseError, number>({
  queryKey: [COLLECTION_PATH, 'organizations-count'],
  queryFn: async (): Promise<number> => getCollectionLength(COLLECTION_PATH),
  retry: 0,
  ...options,
});
